import { useConfig } from "@/api/hooks/useConfig";
import { useTrans } from "@/translations";

import React from "react";
import { NavLink, useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";

import { twMerge } from "tailwind-merge";

import type { NavItemInterface } from "../Sidebar.interface";
import { Portal } from "./utils";

export const NavItem: React.FC<
  NavItemInterface & { collapsedSidebar: boolean }
> = ({ to, name, icon, collapsedSidebar }) => {
  const { t } = useTrans();
  const { client } = useParams();
  const { useClientPath } = useConfig();

  return (
    <NavLink
      to={useClientPath ? `/${client}${to}` : to}
      className={({ isActive }) =>
        `hover:bg-buttery-lime flex h-8 items-center transition-colors ${
          isActive ? "bg-lime-light" : ""
        } ${collapsedSidebar ? "w-full" : "pl-[25px]"}`
      }
      end={to === "/"}
      id={name}
      data-tooltip-id={name}
      data-tooltip-delay-show={1000}
    >
      <div
        className={twMerge(
          "relative flex items-center",
          collapsedSidebar && "w-full items-center justify-center",
        )}
      >
        {icon}
        {!collapsedSidebar && (
          <div className="ml-[11px] text-[13px]">{t(name)}</div>
        )}

        {collapsedSidebar && (
          <Portal>
            <Tooltip
              id={name}
              place="right"
              className="z-10000"
              content={t(name)}
              noArrow
              opacity={1}
            />
          </Portal>
        )}
      </div>
    </NavLink>
  );
};
